import React, { Fragment, useEffect } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import ServiceSection from '../../components/ServiceSection/ServiceSection';
import Scrollbar from '../../components/scrollbar/scrollbar'
import TechStack from '../../components/techstack/TechStack';
import Footer from '../../components/footer/Footer';
import Logo from '../../images/logo-2.svg'
import Phone from '../../images/telephone.svg'
// import CursorMaus from '../../components/CursorMaus/CursorMaus';
import LenisSmoothScroll from '../../components/lenissmoothscroll/LenisSmoothScroll';

const ServicePage = () => {
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);
    return (
        <Fragment>
            <Navbar Logo={Logo} hclass={"wpo-site-header s3"} telephone={Phone} />
            <PageTitle pageTitle={'Services'} pagesub={'Our Services'} />
            <ServiceSection hclass={'services-section-s3'}/>
            <TechStack />
            <Footer />
            <Scrollbar /> 
            {/* <CursorMaus /> */}
            < LenisSmoothScroll />
        </Fragment>
    )
};
export default ServicePage;
